/*
 * w-configurator-state.js
 *
 * Nouvelle source de verite du state du configurateur Poiray v2 (Phase 1).
 * Charge AVANT w-watch-configurator.js par sections/w-watches-configurator.liquid.
 *
 * Decisions Phase 1 :
 *  - D-01 : offeredStraps/paidStraps/tier = nouvelle source de verite, strap/additionalStrap
 *           deviennent des getters/setters de compat (30+ consumers existants inchanges).
 *  - D-02 : slots indexes par cles numeriques { 1: null, 2: null, 3: null }.
 *  - D-03 : shape d'un slot rempli = ancien strap + champ materialCode pre-calcule.
 *  - D-06 : killswitch window.CONFIGURATOR_V2_COMPAT = true par defaut ; false restaure
 *           le shape plat d'origine (filet de securite pour git revert progressif).
 *  - D-07 : fichier separe, charge AVANT le configurateur principal.
 *  - D-09 : getMaterialCode = longest-prefix-match sur whitelist ordonnee par longueur decroissante.
 *  - D-10 : SKU inconnu -> null + console.warn avec le SKU pour debug catalogue.
 *  - D-11 : tolerance composite via split(' + ')[0] AVANT matching.
 *
 *  - D-07 (Phase 3) : OPTION A — paidStraps[2] = slot droite (data-offered-slot-index=2),
 *           paidStraps[3] = slot gauche (data-offered-slot-index=3). Le shim additionalStrap[1]
 *           pointe vers paidStraps[2] (semantique "1er paid" = slot droite). additionalStrap[2]
 *           pointe vers paidStraps[3] (semantique "2eme paid" = slot gauche). paidStraps[1] reste
 *           dans la factory mais N'EST JAMAIS rempli en Phase 3 (cap = 2 paid max — voir CONTEXT D-01).
 *
 * Script console de validation d'egalite (a coller dans DevTools [K]DEV apres selectStrap) :
 *   const s = document.querySelector('watch-configurator').selection;
 *   console.assert(s.strap === s.offeredStraps[1], 'strap != offeredStraps[1]');
 *   // Phase 3 D-07 Option A : additionalStrap[1] -> paidStraps[2], additionalStrap[2] -> paidStraps[3].
 *   console.assert(s.additionalStrap[1] === s.paidStraps[2], 'add[1] != paid[2] (Phase 3 Option A)');
 *   console.assert(s.additionalStrap[2] === s.paidStraps[3], 'add[2] != paid[3] (Phase 3 Option A)');
 *   console.assert(Number.isInteger(s.tier) && s.tier >= 1 && s.tier <= 3, 'tier invalide');
 *
 * Bascule killswitch (en DevTools) :
 *   window.CONFIGURATOR_V2_COMPAT = false;
 *   document.querySelector('watch-configurator').initVars(); // ou reload de la page
 */

window.CONFIGURATOR_V2_COMPAT =
  typeof window.CONFIGURATOR_V2_COMPAT === "boolean"
    ? window.CONFIGURATOR_V2_COMPAT
    : true;

// Whitelist des prefixes matiere TRIEE par longueur decroissante (D-09).
// Source de verite : window.strapCollection (measured on [K]DEV 2026-04-23).
// Retire PTIP (0 variants reels dans le catalogue) et ajoute PVF (44 variants reels, famille vachette).
// L'ordre est critique : PCLM avant PCL, PVV avant PV, PVF avant PV pour eviter les faux matches.
// Les 14 variants numeriques "609xxx" (perles/metal) sont geres via court-circuit en amont (leur matiere
// provient de product.family, pas du prefixe SKU) — ils ne sont pas dans cette whitelist.
var __MATERIAL_PREFIXES = ["PCLM", "PVV", "PVF", "PCL", "PV", "PA", "PL"];

function getMaterialCode(sku) {
  if (typeof sku !== "string" || sku.length === 0) return null;
  // D-11 : tolerance format composite 'PCLM001 12mm + BA/12AC' ou 'PV-veau-noir + BOUCLE-acier'.
  var normalized = sku.split(" + ")[0];
  // Court-circuit silent-null pour les SKU purement numeriques (14 variants "609xxx" pour perles
  // d'eau douce et metal — leur matiere vient de product.family, pas du prefixe SKU).
  // Retourne null SANS console.warn : ce n'est pas une erreur, c'est un cas hors perimetre prefixe.
  if (/^\d/.test(normalized)) return null;
  // Longest-prefix-match via regex "prefixe suivi de non-lettre majuscule" (digit, space, dash, EOF).
  // Gere le format reel du catalogue Poiray 'PV013 12mm' (digit accole) ET le format idealise
  // 'PV-veau-noir' (tiret). Le lookahead (?![A-Z]) garantit que 'PVF011' ne matche pas 'PV' car
  // apres 'PV' vient 'F' (majuscule) — PVF sera teste en premier grace au tri longest-first.
  for (var i = 0; i < __MATERIAL_PREFIXES.length; i++) {
    var code = __MATERIAL_PREFIXES[i];
    var re = new RegExp("^" + code + "(?![A-Z])");
    if (re.test(normalized)) return code;
  }
  // D-10 : laisser une trace debug mais ne pas crasher. Declenche seulement pour prefixes
  // reellement inconnus (pas pour les SKU numeriques, geres plus haut).
  console.warn("[getMaterialCode] Unknown material prefix in SKU: " + sku);
  return null;
}

// Bornes en centimes Shopify (les prix dans data-dial-price sont en centimes).
// TIER-02 : cadran < 3500 EUR (< 350000 centimes) -> palier 1 (1 bracelet offert).
// TIER-03 : cadran >= 3500 et < 9050 EUR (350000 <= p < 905000) -> palier 2 (2 bracelets offerts).
// TIER-04 : cadran >= 9050 EUR (>= 905000 centimes) -> palier 3 (3 bracelets offerts).
var __TIER_2_MIN_CENTIMES = 350000;
var __TIER_3_MIN_CENTIMES = 905000;

function computeTier(dialPriceCentimes) {
  if (dialPriceCentimes === null || dialPriceCentimes === undefined) return null;
  var p =
    typeof dialPriceCentimes === "number"
      ? dialPriceCentimes
      : parseInt(dialPriceCentimes, 10);
  if (!Number.isFinite(p)) return null;
  if (p < __TIER_2_MIN_CENTIMES) return 1;
  if (p < __TIER_3_MIN_CENTIMES) return 2;
  return 3;
}

function createSelectionState() {
  // D-06 : killswitch renvoie l'ancien shape plat a l'identique de w-watch-configurator.js:210
  // pour permettre une bascule console sans reloader.
  if (window.CONFIGURATOR_V2_COMPAT === false) {
    return {
      collection: null,
      collection_size: null,
      title: null,
      dial: null,
      dialPrice: null,
      strap: {},
      strapOnlyPicture: null,
      clasp: null,
      additionalStrap: { 1: null, 2: null },
      totalPrice: null,
    };
  }

  // D-02 : slots indexes par cles numeriques. null par defaut (pas rempli).
  // ATTENTION T-01-01 : ces deux variables sont capturees par closure par les
  // getters/setters ci-dessous. NE JAMAIS remplacer `offeredStraps[1]` par
  // `state.offeredStraps[1]` ou `this.offeredStraps[1]` dans les getters sous peine
  // de recursion infinie (le getter de state.strap lirait state.offeredStraps[1]
  // qui est deja accessible directement, mais un getter qui reappellerait lui-meme
  // via state.strap provoquerait un stack overflow).
  var offeredStraps = { 1: null, 2: null, 3: null };
  var paidStraps = { 1: null, 2: null, 3: null };

  // D-03 : slot 1 initialise a objet vide pour preserver l'ancien code
  // qui faisait directement this.selection.strap.title = ... sans verifier
  // l'existence de l'objet (cf w-watch-configurator.js:1195).
  offeredStraps[1] = {};

  // D-01 : nouvelle source de verite + getters/setters de compat.
  var state = {
    collection: null,
    collection_size: null,
    title: null,
    dial: null,
    dialPrice: null,
    strapOnlyPicture: null,
    clasp: null,
    totalPrice: null,
    tier: null,
    offeredStraps: offeredStraps,
    paidStraps: paidStraps,
  };

  // Compat `strap` <-> offeredStraps[1]. Closure sur var locale offeredStraps.
  Object.defineProperty(state, "strap", {
    enumerable: true,
    configurable: true,
    get: function () {
      return offeredStraps[1];
    },
    set: function (v) {
      offeredStraps[1] = v;
    },
  });

  // Compat `additionalStrap` : lecture/ecriture transparente vers paidStraps.
  // Closure sur var locale paidStraps — ne PAS utiliser state.paidStraps ni this.paidStraps.
  var additionalStrapCompat = {};
  Object.defineProperty(additionalStrapCompat, "1", {
    enumerable: true,
    configurable: true,
    // Phase 3 D-07 Option A : additionalStrap[1] (semantique legacy "1er paid") -> paidStraps[2]
    // (slot droite, visuellement = data-offered-slot-index="2"). Mapping change vs Phase 1
    // (ou additionalStrap[1] -> paidStraps[1]). paidStraps[1] reste dans la factory mais
    // n'est jamais rempli en Phase 3 (cap = 2 paid max via slots 2 et 3).
    get: function () {
      return paidStraps[2];
    },
    set: function (v) {
      paidStraps[2] = v;
    },
  });
  Object.defineProperty(additionalStrapCompat, "2", {
    enumerable: true,
    configurable: true,
    // Phase 3 D-07 Option A : additionalStrap[2] (semantique legacy "2eme paid") -> paidStraps[3]
    // (slot gauche, visuellement = data-offered-slot-index="3"). Mapping change vs Phase 1
    // (ou additionalStrap[2] -> paidStraps[2]).
    get: function () {
      return paidStraps[3];
    },
    set: function (v) {
      paidStraps[3] = v;
    },
  });

  Object.defineProperty(state, "additionalStrap", {
    enumerable: true,
    configurable: true,
    get: function () {
      return additionalStrapCompat;
    },
    // setter permet aussi de faire this.selection.additionalStrap = { 1:null, 2:null }
    // (pattern de reset utilise par checkIfHasSelection). Phase 3 D-07 Option A : reset
    // { 1, 2 } -> mute paidStraps[2] et [3] (mapping symetrique des getters ci-dessus).
    set: function (v) {
      if (v && typeof v === "object") {
        paidStraps[2] = v[1] !== undefined ? v[1] : null;
        paidStraps[3] = v[2] !== undefined ? v[2] : null;
      }
    },
  });

  return state;
}
